import React, { FC, useState } from 'react';

import './CheckSignCode.scss';
import TemplateModal from 'components/common/modals/TemplateModal';
import Button from 'components/common/ui-kit/Button';
import { InputV2 } from 'components/common/ui-kit/Input/view';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import { createToast, hideModal } from 'redux/actions';
import { contractApi } from 'redux/api/applications/contract-api';
import { modalDataSelector } from 'redux/selectors';
import { staffContractsSlice } from 'redux/slices/staff/staffContractsSlice';

const CheckSignCode: FC = () => {
  const [signContract] = contractApi.useSignContractMutation();
  const dispatch = useAppDispatch();
  const { contractId } = useAppSelector(modalDataSelector);
  const [key, setKey] = useState('');
  const closeModal = () => dispatch(hideModal());
  const [isLoading, setIsLoading] = useState(false);
  const handleSave = () => {
    if (isLoading) return;
    setIsLoading(true);
    signContract({ id: contractId, key })
      .unwrap()
      .then(result => {
        dispatch(createToast('Договор подписан', 'success'));
        dispatch(staffContractsSlice.actions.updateContract(result));
        closeModal();
      })
      .catch(error => {
        dispatch(createToast(error.data.message, 'danger'));
      })
      .finally(() => {
        setIsLoading(false);
        setKey('');
      });
  };
  return (
    <TemplateModal title="Ключ для подписи">
      <div className="check-sign-modal">
        <div className="code-row">
          <InputV2
            type="string"
            value={key}
            onChange={e => setKey(e.target.value)}
            placeholder="Введите ключ для подписания договора"
          />
        </div>
        <div className="code-row">
          <Button disabled={isLoading} theme="success" onClick={handleSave}>
            {isLoading ? 'Отправка...' : 'Отправить'}
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default CheckSignCode;
